import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { ContainerComponent } from './container/container.component'
import { RouterModule } from '@angular/router'
import { InfographicSliderComponent } from './infographic-slider/infographic-slider.component'
import { LoginService } from 'src/app/services/login.service'
import { UtilityService } from 'src/app/services/utility.service'
import { HttpClientModule } from '@angular/common/http'
import { RoutingWrapperComponent } from './routing-wrapper/routing-wrapper.component'
import { SigninUpToggleModule } from 'src/app/shared/signin-up-toggle/signin-up-toggle.module'
import { VLoaderModule } from 'src/app/shared/v-loader/v-loader.module'
import { FormLoaderModule } from 'src/app/shared/form-loader/form-loader.module'
import { LoginGuard } from 'src/app/guards/login.guard'

@NgModule({
  declarations: [ContainerComponent, InfographicSliderComponent, RoutingWrapperComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    SigninUpToggleModule,
    VLoaderModule,
    FormLoaderModule,
    RouterModule.forChild([
      {
        path: '',
        component: ContainerComponent,
        children: [
          {
            path: '',
            redirectTo: '/signin',
            pathMatch: 'full',
          },
          { path: 'signin', canLoad: [LoginGuard], loadChildren: () => import('../../pages/signin/signin.module').then((m) => m.SigninModule) },
          { path: 'signup', loadChildren: () => import('../../pages/signup/signup.module').then((m) => m.SignupModule) },
          { path: 'login', canLoad: [LoginGuard], loadChildren: () => import('../../pages/sso-ad/sso-ad.module').then((m) => m.SsoAdModule) },
          { path: 'change-password', loadChildren: () => import('../../pages/change-password/change-password.module').then((m) => m.ChangePasswordModule) },
          { path: 'forgot-password', loadChildren: () => import('../../pages/forgot-password/forgot-password.module').then((m) => m.ForgotPasswordModule) },
        ],
      },
    ]),
  ],
  providers: [LoginService, UtilityService],
})
export class ContainerLayoutModule {}
